const BYPASS_MODES = ['2', '3']

export const checkBypassMode = (utmBp: any): boolean => {
  if (utmBp && typeof utmBp === 'number') {
    return BYPASS_MODES.includes(String(utmBp))
  }
  return BYPASS_MODES.includes(utmBp)
}

/**
 * Google Search Ads paid traffic (`utm_bp=2`).
 * Distinct from Google Hotel Ads / metasearch (`utm_bp=3`).
 */
export function isPaidSearch(utmBp?: string | number | null): boolean {
  return String(utmBp) === '2'
}
